import { gql } from '@apollo/client';

export const GET_RATES = gql`
  query Rates($tenantId: String!) {
    rates(tenantId: $tenantId) {
      id
      code
      source
      destination
      rate
    }
  }
`;

export const ADD_RATE = gql`
  mutation AddRate(
    $tenantId: String!
    $source: String!
    $destination: String!
    $rate: Float!
  ) {
    addRate(
      tenantId: $tenantId
      source: $source
      destination: $destination
      rate: $rate
    ) {
      code
      success
      message
      rate {
        id
        code
        source
        destination
        rate
      }
    }
  }
`;

export const UPDATE_RATE = gql`
  mutation UpdateRate($tenantId: ID!, $id: ID!, $rate: Float!) {
    updateRate(tenantId: $tenantId, id: $id, rate: $rate) {
      code
      success
      message
      rate {
        id
        code
        source
        destination
        rate
      }
    }
  }
`;

export const FUND_TENANT_RATE = gql`
  mutation FundTenantRate(
    $tenantId: String!
    $currency: String!
    $amount: Float!
  ) {
    fundTenantRate(tenantId: $tenantId, currency: $currency, amount: $amount) {
      code
      success
      message
    }
  }
`;
